$(() => {
  // Verifica hash ao iniciar

  ;(<any>$('#p5fw-accessibility-buttons')).p5fwAccessibility()

  URI.init()

  //PopUP's
  if ($('#popupModal').length === 1) {
    ;(<any>$('#popupModal')).modal('show')
  }

  // Menu Mobile
  $(document).off('click', '.menu-mobile')
  $(document).on('click', '.menu-mobile', function (e) {
    e.stopPropagation()
    $('.menu-mobile-container').addClass('open')
  })

  $(document).off('click', '.menu-mobile-container-click')
  $(document).on('click', '.menu-mobile-container-click', function (e) {
    e.stopPropagation()
    $('.menu-mobile-container').removeClass('open')
    ;(<any>$('.menu-collapse')).collapse('hide')
  })

  $(document).on('click', function (e) {
    if ($(e.target).closest('.menu-mobile-container').length === 0) {
      $('.menu-mobile-container').removeClass('open')
      ;(<any>$('.menu-collapse')).collapse('hide')
    }
  })

  // Search
  $('#search-btn').click(function () {
    let search: any = $('#search').val()
    if (search.length > 2) {
      window.location.href = '/#/search/' + encodeURIComponent(search)
    }
  })

  $('#search').keyup(function (event: any) {
    if (event.keyCode == 13) {
      $('#search-btn').click()
    }
  })

  $('#search-btn-m').click(function () {
    let search: any = $('#search-m').val()
    if (search.length > 2) {
      window.location.href = '/#/search/' + encodeURIComponent(search)
    }
  })

  // Back to TOP
  // var menuTop = $("#menu-desktop").offset().top;
  // $(window).scroll(function(){
  //     let scrollTop = $(window).scrollTop();
  //     if (scrollTop > (menuTop)) {
  //         $("#footer-btn-back-top").show("slow");
  //     } else {
  //         $("#footer-btn-back-top").hide("slow");
  //     }
  // });

  // $("#footer-btn-back-top").click(function(){
  //     $('body, html').animate({scrollTop: 0}, 900);
  // });
})
